const resolveDefault = (defaultStore) => {
    if (typeof defaultStore === 'function')
        return defaultStore();
    if (defaultStore)
        return defaultStore;
    if (typeof globalThis === 'undefined')
        return null;
    const candidate = globalThis.localStorage;
    return candidate ?? null;
};
export const createSessionHelpers = (options) => {
    if (options.storageKey.length === 0)
        throw new Error('storageKey must not be empty');
    const resolve = (override) => {
        if (override)
            return override;
        return resolveDefault(options.defaultStore);
    };
    return {
        getToken(override) {
            const store = resolve(override);
            if (!store)
                return null;
            const token = store.getItem(options.storageKey);
            return typeof token === 'string' && token.length > 0 ? token : null;
        },
        isAuthenticated(override) {
            const store = resolve(override);
            if (!store)
                return false;
            const token = store.getItem(options.storageKey);
            return typeof token === 'string' && token.length > 0;
        },
        setSessionToken(token, override) {
            const store = resolve(override);
            if (!store)
                throw new Error('No session store available');
            if (token.length === 0)
                throw new Error('Session token must not be empty');
            store.setItem(options.storageKey, token);
        },
        clearSession(override) {
            const store = resolve(override);
            if (!store)
                return;
            store.removeItem(options.storageKey);
        },
    };
};
//# sourceMappingURL=session-store.js.map